export default {
  questions: {
    common: {
      dropdownPlaceholder: 'Seleziona:'
    },
    comments: {
      additionalComments: 'Commenti aggiuntivi',
      enter: 'Inserisci qui il tuo testo',
      title: 'Ci sono altri commenti che vorresti condividere con noi?' //Dynamic use

    },
    menuInsight: {
      areYouSureYouWantToClose: 'Sei sicuro di voler chiudere?',
      theInformationYouHaveEnteredHere: 'Le informazioni che hai inserito qui non verranno salvate',
      moreCharactersRequired: "Immettere tre o più caratteri per cercare l'articolo." // Deepl translated -> Requires proper translation

    },
    nps: {
      notVeryLikely: 'Non molto probabile',
      sliderDesc: 'Tocca sotto per selezionare un punteggio',
      sliderDirtyDesc: 'Scorri per cambiare il tuo punteggio',
      veryLikely: 'Molto probabile'
    },
    questions: {
      na: 'Non Applicabile'
    },
    staff: {
      areYouSureYouWantToClose: 'Sei sicuro di voler chiudere?',
      theInformationYouHaveEnteredHereWontBeSaved: 'Le informazioni che hai inserito qui non verranno salvate'
    },
    yesNoWhy: {
      whyIsThat: 'Come mai quello?'
    },
    saveAndContinue: 'Salva e continua',
    areYouSureYouWantToClose: 'Sei sicuro di voler chiudere?',
    theInformationYouHaveEnteredHere: 'Le informazioni che hai inserito qui non verranno salvate'
  }
};